<template>
    <div id="MyRecord">
        <div class="record_header">
            <div class="record_header_l">
            </div>
            <div class="record_header_c">
                个人明细
            </div>
            <div class="record_header_r">
            </div>
        </div>

        <div class="record_content_wrap">
            <div class="record_title">
                <p>状态</p>
                <p>类别</p>
                <p>金额</p>
                <p>时间</p>
            </div>
            <div class="list_wrap">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false"
                    @load="onLoad">
                    <div class="list_item" v-for="(item, index) in list" :key="index">
                        <p style="color: #6a77ff;">已付款</p>
                        <p>充值</p>
                        <p style="color: #E9B85A;">{{ item.bean }}</p>
                        <p style="color: #c6c7d3;">{{item.code}}</p>
                    </div> 
                </van-list>
            </div>

        </div>

    </div>
</template>

<script>
import {
    Recharge_record,
} from '@/network/api.js'
export default {
    name: 'MyRecord',
    data() {
        return {
            //列表
            list: [],
            // 加载状态
            loading: true,
            // 是否加载结束
            finished: false,
            // 页码值
            pagenum: 1,
            //条数
            pageSize: 10,
            // 数据总条数
            total: "",

        }
    },

    created() {
        this.loadList();
    },

    methods: {
        loadList() {
            Recharge_record(this.pagenum).then((res) => {
                let rows = res.data.data.data;
                // 如果返回的数组是空或数组长度是0
                if (rows == null || rows.length === 0) {
                    this.loading = false; // 关闭加载状态
                    this.finished = true; // 加载结束
                    return;
                }
                console.log(rows);
                //this.total = res.data.data.total
                //this.per_page = res.data.data.per_page
                this.loading = false; // 关闭加载状态
                this.total = 50;  //这里写死 数据总条数
                this.list = this.list.concat(rows); //合并数组

                // 如果合并之后的数组长度大于返回的数据总条数
                if (this.list.length >= this.total) {
                    this.finished = true; // 加载结束
                }

            })

        },

        // 上拉加载
        onLoad() {
            this.pagenum += 1;
            this.loadList();
        }

    },
}

</script>

<style lang="scss">
#MyRecord {
    box-sizing: border-box;
    padding-top: 3px;
    width: 100%;
    min-height: 500px;
    padding-bottom: 50px;

    .record_header {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        color: #8488a6;
        font-size: 16px;

        .record_header_l {
            display: flex;
            align-items: center;
            flex: 1;
        }

        .record_header_c {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 197px;
            height: 105px;
            background: url(../../../assets/images/setting/header_bg.png) center no-repeat;
            background-size: 100% 100%;
            color: #fff;
            font-size: 24px;

        }

        .record_header_r {
            flex: 1;
        }

    }

    .record_content_wrap {
        width: 100%;

        .record_title {
            width: 100%;
            height: 66px;
            background: #111324;
            box-sizing: border-box;
            padding: 0 30px;
            display: flex;
            align-items: center;
            color: #5d5f72;
            font-size: 13px;
            font-weight: 700;

            p {
                flex: 1;
                align-items: center;
                display: flex;
                cursor: pointer;

                &:last-child {
                    flex: none;
                    width: 180px
                }
            }
        }

        .list_wrap {
            display: flex;
            flex-direction: column;
            width: 100%;

            .list_item {
                width: 100%;
                height: 56px;
                background: #131528;
                box-sizing: border-box;
                padding: 0 30px;
                display: flex;
                align-items: center;
                margin-bottom: 2px;

                p {
                    font-family: Oxanium;
                    flex: 1;
                    &:last-child {
                        flex: none;
                        width: 180px
                    }
                }
            }
        }
    }
}
</style>